import type { Action } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../../../../common/types/index.tsx';
import { fetchEditableAttributeTypes } from '../fetch-editable-attribute-types/index.tsx';
import { fetchObjectConfiguration } from '../fetch-object-configuration/index.tsx';

export const fetchObjectViewInitialData =
	(): Action<InsightObjectViewState, ContainerProps> =>
	async ({ setState, dispatch }) => {
		setState({ loading: true });
		const objectConfigRequest = dispatch(fetchObjectConfiguration());
		const editableAttributeTypesRequest = dispatch(fetchEditableAttributeTypes());
		try {
			await Promise.all([objectConfigRequest, editableAttributeTypesRequest]);
		} finally {
			setState({ loading: false });
		}
	};
